// Nombre de la compañía interna del tenant (la del reseller). Los tickets que
// abre o sufre el personal propio se registran contra ella: sin compañía el
// ticket no se puede triar, y "sin compañía" ya no es una opción.
// Se deriva del tema activo (VITE_THEME) SÓLO para los tenants cuya compañía
// interna sigue la convención `<tema>-reseller`. Un tema desconocido (p. ej. el
// `central-gps` que los despliegues de desarrollo usan por defecto cuando falta
// la variable) muestra un texto genérico en vez de inventar una compañía que no
// existe.
const KNOWN_TENANT_THEMES = ["dumax", "wayak", "nuvex", "coding-cloud"];

export function resolveInternalCompanyName(theme: string | undefined): string {
  const t = (theme || "").trim().toLowerCase();
  return KNOWN_TENANT_THEMES.includes(t) ? `${t}-reseller` : "interna del reseller";
}

export const INTERNAL_COMPANY_NAME = resolveInternalCompanyName(import.meta.env.VITE_THEME);
